import { useState, useContext, useEffect } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import "./Tabs.styles.css";
import { PanelHorizontal } from './PanelHorizontal';
import { SvgComponent } from '../../SvgComponent/SvgComponent';
import { PanelHorizontalProvider } from '../../../Providers';
import { ActividadesContext } from '../../../Contexts';
import {useAuthentication, useTheme} from '../../../Hooks';
import { FacturasSection } from '../../MiCuenta/FacturasSection';
import { ReferidosSection } from '../../MiCuenta/ReferidosSection';
import { SolicitudesSection } from '../../MiCuenta/SolicitudesSection';
import { ConfiguracionCuenta } from '../../MiCuenta/ConfiguracionSection';
import { CuentaSection } from '../../MiCuenta/CuentaSection';

function RightSection(props){
    const { theme } = useTheme();
    let setFuente;
    let setReferencia;
    const DEFAULT_TAB = "cuenta";
    const fillColor = "#3f3f3f";
    const iconStyle = { marginRight: "10px" };
    const [currentTab, setCurrentTab] = useState(DEFAULT_TAB);
    const [isScrollable, setIsScrollable] = useState(false);
    const [esCompaniaPrueba, setEsCompaniaPrueba] = useState(false);
    const {usuario} = useAuthentication();

    useEffect(() => {
        handleSelect(DEFAULT_TAB);
    }, []);

    useEffect(() => {
        if (setFuente) {
            setFuente(props.Fuente);
        }

        if (setReferencia) {
            setReferencia(props.Referencia);
        }
    }, [setFuente, setReferencia, props]);
    useEffect(() => {
        if(usuario) {
            setEsCompaniaPrueba(usuario.Compania?.Configuracion.EsCompaniaPrueba);
        }
    }, [usuario]);
    const handleSelect = (keyevent) => {
        const scrollableTabs = [DEFAULT_TAB, "log", "historico", "Comentarios", "Notas"];
        scrollableTabs.indexOf(keyevent) != "-1"
            ? setIsScrollable(true)
            : setIsScrollable(false);
    };

    return (
        <div
            className="bootstrapiso right-section d-flex flex-row"
            style={{
                minHeight: props.simplebar
                    ? `85vh`
                    : `calc(100vh - ${theme.MAX_HEIGHT_HEADER})`,
                overflowY: "hidden",
                overflowX: "hidden",
                background: "white",
            }}
        >
            <div style={{ width: "97%", borderRight: `2px solid #e5e5e5 ` }}>
                <div
                    style={{
                        overflow: "auto",
                        minHeight: props.simplebar
                            ? `85vh`
                            : `calc(100vh - ${theme.MAX_HEIGHT_HEADER}) - 500px)`,
                        overflowY: isScrollable ? "auto" : "hidden",
                        overflowX: "hidden",
                    }}
                >
                    <Tab.Container
                        id="icons-tabs"
                        defaultActiveKey={DEFAULT_TAB}
                        activeKey={currentTab}
                        fill
                        
                        onSelect={(e) => {
                            setCurrentTab(e);
                            handleSelect(e);
                        }}
                    >
                        <Nav role="tablist" variant="tabs">
                            <Nav.Item>
                                <Nav.Link eventKey="cuenta">
                                    <SvgComponent
                                        fill={fillColor}
                                        style={iconStyle}
                                        width="25px"
                                        height="25px"
                                        iconName="id-card"
                                    />
                                    Mi Cuenta
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="log" disabled={esCompaniaPrueba}>
                                    <SvgComponent
                                        fill={fillColor}
                                        style={iconStyle}
                                        width="25px"
                                        height="25px"
                                        iconName="balance"
                                    />
                                    Mis Facturas y Balance
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="historico" disabled={esCompaniaPrueba}>
                                    <SvgComponent
                                        fill={fillColor}
                                        style={iconStyle}
                                        width="25px"
                                        height="25px"
                                        iconName="manufacturing"
                                    />
                                    Mis Configuraciones
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="Comentarios" disabled={esCompaniaPrueba}>
                                    <SvgComponent
                                        fill={fillColor}
                                        style={iconStyle}
                                        width="25px"
                                        height="25px"
                                        iconName="referidos"
                                    />
                                    Mis Referidos
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="Notas" style={{paddingBottom: '0.75rem'}} disabled={esCompaniaPrueba}>
                                    <SvgComponent
                                        fill={fillColor}
                                        style={iconStyle}
                                        width="20px"
                                        height="20px"
                                        iconName="notes"
                                    />
                                    Mis Solicitudes
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content>
                            <Tab.Pane eventKey="cuenta">
                                <Tab.Container
                                    id="icons-tabs-Cuenta"
                                    defaultActiveKey="cuenta"
                                >
                                    <CuentaSection cuentaInfo={props.CuentaInfo} />
                                </Tab.Container>
                            </Tab.Pane>
                            <Tab.Pane eventKey="log">
                                <Tab.Container
                                    id="icons-tabs-Actividades"
                                    defaultActiveKey="log"
                                >
                                    <FacturasSection 
                                        showLoading={props.showLoading}
                                        hideLoading={props.hideLoading}
                                    />
                                </Tab.Container>
                            </Tab.Pane>
                            <Tab.Pane eventKey="historico">
                                <Tab.Container
                                    id="icons-tabs-Actividades"
                                    defaultActiveKey="historico"
                                >
                                    {!esCompaniaPrueba && (
                                        <ConfiguracionCuenta
                                            showLoading={props.showLoading}
                                            hideLoading={props.hideLoading}
                                            setCurrentTab={setCurrentTab}
                                        />
                                    )}
                                </Tab.Container>
                            </Tab.Pane>
                            <Tab.Pane eventKey="Comentarios">
                                <Tab.Container
                                    id="icons-tabs-Actividades"
                                    defaultActiveKey="Comentarios"
                                >
                                    {!esCompaniaPrueba && (
                                        <ReferidosSection />
                                    )}
                                        
                                </Tab.Container>
                            </Tab.Pane>
                            <Tab.Pane eventKey="Notas">
                                <Tab.Container
                                    id="icons-tabs-Actividades"
                                    defaultActiveKey="Notas"
                                >
                                </Tab.Container>
                                {!esCompaniaPrueba && (
                                    <SolicitudesSection
                                        fuente={props.Fuente}
                                        referencia={props.Referencia}
                                        crearNuevo={props.PanelCollapsable.sections.find(section => section.title === "Solicitudes").onClick}
                                    />
                                )}
                                    
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </div>

            <PanelHorizontalProvider>
                <PanelHorizontal {...props}></PanelHorizontal>
            </PanelHorizontalProvider>
        </div>
    );
    
}
export default RightSection;
